import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgbAccordionCollapse, NgbAccordionItem, NgbAccordionToggle } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-toggle-field',
  standalone: false,
  templateUrl: './toggle-field.component.html',
  styleUrl: './toggle-field.component.scss'
})
export class ToggleFieldComponent {
  @Input() fieldName: string;
  @Input() isExpandable: boolean = false;
  @Input() collapsed: boolean = true;
  @Input() checked: boolean;
  @Input() toggleVisible: boolean = true;

  @Output() toggleChange = new EventEmitter<boolean>();

  onCheckboxChange(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.toggleChange.emit(isChecked);
  }
}
